import { ref, watch } from 'vue';
import { defineStore, storeToRefs } from 'pinia';

export const useThemeStore = defineStore('settings', () => {
    const currentTheme = ref<'dark' | 'light'>('light');

    watch(currentTheme, () => {
        localStorage.setItem('bs-theme', currentTheme.value);

        document.querySelector('html')?.setAttribute('data-bs-theme', currentTheme.value);
    });

    const storedTheme = localStorage.getItem('bs-theme') as 'dark' | 'light';

    currentTheme.value = storedTheme || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');

    /**
     * Set a new theme
     * @param theme
     */
    const setTheme = (theme: 'dark' | 'light') => {
        currentTheme.value = theme;
    };

    return { currentTheme, setTheme };
});

export const useThemeStoreRef = () => storeToRefs(useThemeStore());
